import React, { useState, useContext, useRef, useEffect } from 'react';
import { MyContext } from '../../Context/MyProvider';
import VegIcon from "../../Icon/veg.svg";
import NonVegIcon from "../../Icon/nonveg.svg";

import secureLocalStorage from 'react-secure-storage';

const ImageLoad = ({ BaseUrl, url, CustomeStyle }) => {
    const [imgLoaded, setImgLoaded] = useState(false);

    if (!url) {
        return;
    }

    return (<>
        <img
            src={`${BaseUrl}/${url}`}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${CustomeStyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    </>)
}

const ProductData = ({ index, item, itemlist, currency, setSelectItem, handleAllFuction, status, sectionRefs }) => {

    const [showitem, setShowItem] = useState(true);

    return <div id={item.title} ref={sectionRefs.current[item.id]} className="product_box">
        <div className="flex items-center justify-between">
            <h1 className="title">{item.title} ({item.Menuitem_Data?.length})</h1>
            <button onClick={() => setShowItem(!showitem)}>
                {showitem
                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 15.75C18.808 15.75 18.616 15.6771 18.47 15.5301L12 9.06008L5.53005 15.5301C5.23705 15.8231 4.76202 15.8231 4.46902 15.5301C4.17602 15.2371 4.17602 14.762 4.46902 14.469L11.469 7.46902C11.762 7.17602 12.2371 7.17602 12.5301 7.46902L19.5301 14.469C19.8231 14.762 19.8231 15.2371 19.5301 15.5301C19.3841 15.6771 19.192 15.75 19 15.75Z" fill="black" />
                    </svg>
                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 16.75C11.808 16.75 11.616 16.6771 11.47 16.5301L4.46999 9.53005C4.17699 9.23705 4.17699 8.76202 4.46999 8.46902C4.76299 8.17602 5.23803 8.17602 5.53103 8.46902L12.001 14.939L18.471 8.46902C18.764 8.17602 19.239 8.17602 19.532 8.46902C19.825 8.76202 19.825 9.23705 19.532 9.53005L12.532 16.5301C12.384 16.6771 12.192 16.75 12 16.75Z" fill="black" />
                    </svg>}
            </button>
        </div>

        {showitem && item.Menuitem_Data.map((Item, Index) => {
            return <MenuItemData key={Item.id} Index={Index} Item={Item} VegIcon={VegIcon} status={status} currency={currency} Length={item.Menuitem_Data.length} setSelectItem={setSelectItem} handleAllFuction={handleAllFuction} />
        })}

        {index !== (itemlist.length - 1) && <div className="w-full h-[20px] bg-[#f1f2f4] my-[10px]"></div>}

    </div>
}

export default ProductData;

export const MenuItemData = ({ Index, Item, VegIcon, currency, Length, setSelectItem, handleAllFuction, status }) => {

    const isAdded = Item.totalcart >= 1;

    const { BaseUrl, setCustomisableItem, setIsVagType } = useContext(MyContext);
    const [showmore, setShowMore] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [showerror, setShowError] = useState(false);

    const descRef = useRef(null);

    const handleShowBox = (data) => {

        setIsVagType(data.is_veg);
        const LocalData = secureLocalStorage.getItem("localcartdata");

        if (LocalData) {
            const { restdata } = JSON.parse(LocalData);
            if (status?.rest_id !== restdata.rest_id) {
                handleAllFuction(5, data);
                return;
            }
        }

        if (data.is_customize === "0") {
            handleAllFuction(1, data);
            return;
        }

        handleAllFuction(6, data);
    };

    useEffect(() => {
        const element = descRef.current;

        if (element) {
            const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
            const maxLines = 2;
            const isTextOverflowing = element.scrollHeight > lineHeight * maxLines;
            setIsOverflowing(isTextOverflowing);
        }
    }, [Item.cdesc]);

    const handleIncrement = () => {

        if (Item.is_customize === "1" && Item.totalcart >= 1) {
            handleAllFuction(4, Item);
            setSelectItem(Item);
            setCustomisableItem(Item);
            return;
        }

        handleAllFuction(2, Item);
    };

    const handleDecrement = () => {
        const LocalData = secureLocalStorage.getItem("localcartdata");
        if (LocalData) {
            var { cartitem } = JSON.parse(LocalData);
        }

        if (Item.is_customize === "1" && Item.totalcart >= 1) {
            checkOrderAddons(cartitem, Item.id);
            return;
        }

        handleAllFuction(3, Item);
    };

    const checkOrderAddons = (orders, targetPid) => {

        const matchedOrders = orders.filter(order => order.pid === targetPid);

        if (matchedOrders.length === 1) {
            handleAllFuction(3, Item);
            return;
        }

        if (matchedOrders.length > 1) {

            const [first, ...rest] = matchedOrders;
            const firstAddons = first.addon.map(item => item.title).join(", ");
            const firsTitle = [...firstAddons].sort().join(',');

            const AllAddon = rest.every(item => {
                return item.addon.every(addon => {
                    const currentAddons = [...addon.title].sort().join(',');
                    return currentAddons === firsTitle;
                })
            });

            if (AllAddon) {

                const firesOrderTitle = first.addon.map(item => {
                    return item.data.map(item => item.title)
                }).join(", ");

                const SortTitle = [...firesOrderTitle].sort().join(",");

                const allMatch = rest.every(item => {
                    return item.addon.every(addon => {
                        return addon.data.every(data => {
                            const currentAddons = [...data.title].sort().join(',');
                            return currentAddons === SortTitle;
                        })
                    })
                });

                if (allMatch) {
                    handleAllFuction(3, Item);
                } else {
                    setShowError(true);
                    setTimeout(() => {
                        setShowError(false);
                    }, 5000);
                }

            } else {
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, 5000);
            }
        }
    };


    return <div className="item_box">
        <div className={`py-[20px] flex ${Item.item_img ? "items-start" : "items-center"} justify-between gap-[20px] relative`}>
            <div className="detail_box">
                {Item.is_veg === "1" ?
                    <div className="w-[20px]">
                        <img src={VegIcon} alt="VegIcon" />
                    </div>
                    : <div className="w-[20px]">
                        <img src={NonVegIcon} alt="NonVegIcon" />
                    </div>}
                <h1 className="title">{Item.title}</h1>
                <p className="font-[700] text-gray-800 py-[8px]">{currency + Item.price}</p>
                {Item.cdesc && (
                    <div className="flex items-end">
                        <p
                            ref={descRef}
                            className={`text-gray-800 ${showmore ? '' : 'line-clamp-2'} transition-all duration-300`}
                        >
                            {Item.cdesc}
                        </p>
                        {!showmore && isOverflowing && (
                            <button
                                onClick={() => setShowMore(true)}
                                className="ml-2 font-medium text-gray-500"
                            >
                                More
                            </button>
                        )}
                    </div>
                )}
            </div>

            <div className="img_box">
                <ImageLoad BaseUrl={BaseUrl} url={Item.item_img} CustomeStyle={status?.rest_is_open === "1" && "-mb-[25px]"} />
                {status?.rest_is_open === "1" && <div className="">
                    <div className="flex justify-center">
                        {isAdded
                            ? <div className="isAdded">
                                <span onClick={handleDecrement}>-</span>
                                <p>{Item.totalcart}</p>
                                <span onClick={handleIncrement}>+</span>


                            </div>
                            : <button onClick={() => handleShowBox(Item)}>ADD</button>}
                    </div>
                    {Item.is_customize === "1" && <p className="text-center text-gray-500 text-[14px]">Customisable</p>}
                </div>}
            </div>

            {showerror && <div className="absolute -bottom-[80px] right-[65px] z-[666]">
                <div className="error_box">
                    <span>This item has multiple customizations added. Remove the correct item from the cart.</span>
                </div>
            </div>}

        </div>
        {Index !== (Length - 1) && <div className="w-full border-t-[1px] "></div>}

    </div>
}
